import { Link } from "react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  count?: number;
  countLabel?: string;
  backLink?: { to: string; label: string };
  backLinkAction?: React.ReactNode;
  action?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  count,
  countLabel = "items",
  backLink,
  backLinkAction,
  action,
  children,
  className,
}: PageHeaderProps) {
  return (
    <div data-slot="page-header" className={cn("space-y-1", className)}>
      {(backLink || backLinkAction) && (
        <div className="flex items-center justify-between mb-2">
          {backLink ? (
            <Link
              to={backLink.to}
              className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              <IconArrowLeft className="h-3.5 w-3.5" />
              {backLink.label}
            </Link>
          ) : (
            <div />
          )}
          {backLinkAction && <div className="flex-shrink-0">{backLinkAction}</div>}
        </div>
      )}

      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          {title && (
            <h1 data-slot="page-header-title" className="text-lg font-semibold tracking-tight">
              {title}
            </h1>
          )}
          {subtitle && (
            <p data-slot="page-header-subtitle" className="text-sm text-muted-foreground">
              {subtitle}
            </p>
          )}
          {count !== undefined && (
            <p className="text-xs text-muted-foreground/70">
              {count} {countLabel}
            </p>
          )}
          {children}
        </div>

        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
}
